export function navigateToSber(url) {
  const target = new URL(url);
  if (target.origin !== 'https://id.sber.ru' || target.pathname !== '/CSAFront/oidc/authorize.do' || target.username || target.password) {
    throw new Error('Неверный адрес входа Сбер ID');
  }
  window.location.assign(target.href);
}

export function navigateToMobileSber(url) {
  const target = new URL(url);
  if (target.origin !== 'https://prokatprost.ru' || target.pathname !== '/api/client-portal/sber/mobile/launch'
      || target.username || target.password || target.search || !/^#[A-Za-z0-9_-]{43}$/.test(target.hash)) {
    throw new Error('Неверный адрес входа Сбер ID');
  }
  // Android opens this HTTPS address in the external browser, never in WebView.
  window.location.assign(target.href);
}
